export function getInvoiceSeries() {
    return [   
        { code: '1', title: '1'},
        { code: '2', title: '2'},
        { code: '3', title: '3'},
        { code: '4', title: '4'},
        { code: '5', title: '5'},
        { code: '6', title: '6'},
        { code: '7', title: '7'},
        { code: '8', title: '8'},
        { code: '9', title: '9'},
        { code: '10', title: '10'},
        { code: '11', title: '11'},
        { code: '12', title: '12'},     
        { code: 'A', title: 'A'},
        { code: 'B', title: 'B'},
        { code: 'C', title: 'C'},
        { code: 'D', title: 'D'},
        { code: 'E', title: 'E'},
        { code: 'F', title: 'F'},
        { code: 'G', title: 'G'},
        { code: 'H', title: 'H'},
        { code: 'I', title: 'I'},
        { code: 'J', title: 'J'},
        { code: 'K', title: 'K'},
        { code: 'L', title: 'L'},
        { code: 'M', title: 'M'},
        { code: 'N', title: 'N'},
        { code: 'O', title: 'O'},
        { code: 'P', title: 'P'},
        { code: 'Q', title: 'Q'},
        { code: 'R', title: 'R'},
        { code: 'S', title: 'S'},
        { code: 'T', title: 'T'},
        { code: 'U', title: 'U'},
        { code: 'V', title: 'V'},
        { code: 'W', title: 'W'},
        { code: 'X', title: 'X'},
        { code: 'Y', title: 'Y'},
        { code: 'Z', title: 'Z'},
    ];
}

export function getInvoiceSeriesCodes() 
{
    return getInvoiceSeries().flatMap(series => series.code);
}